// Every outcome the server reports for one submitted action, mirroring STATUS in the server's
// utils/constants.js. One value per outcome, so a status is never spelled two ways.
export const STATUS = Object.freeze({
  APPLIED: 'APPLIED',
  DUPLICATE: 'DUPLICATE',
  OUTDATED: 'OUTDATED',
  INACTIVE_SESSION: 'INACTIVE_ASSESSMENT_SESSION',
  REFUSED: 'REFUSED',
  FAILED: 'FAILED',
  NOT_ATTEMPTED: 'NOT_ATTEMPTED',
} as const);

// The results that let the device delete the action: applied, or durably recorded as not applied.
export const SUCCEEDED_STATUSES = [
  STATUS.APPLIED, STATUS.DUPLICATE, STATUS.OUTDATED, STATUS.INACTIVE_SESSION, STATUS.REFUSED,
] as const;
